import $ from 'jquery';
require('./shared/layout');
require('./shared/layout.new.js');

(function () {
  var pathname = window.location.pathname
  var focusedPricingCardId = null
  if (pathname.startsWith('/multistream/')) {
    focusedPricingCardId = 'multistreaming'
  } else if (pathname.startsWith('/livestreaming-cdn/')) {
    focusedPricingCardId = 'livestream_cdn'
  } else if (pathname.startsWith('/prerecorded-live-scheduler')) {
    focusedPricingCardId = 'pre_recorded_live'
  }

  if (focusedPricingCardId) {
    $('.pricing-card').each(function (i, node) {
      if (node.dataset.product && node.dataset.product !== focusedPricingCardId) {
        $(node).addClass('unfocused')
      } else {
        $(node).addClass('focused')
      }
    })
    // $('.pricing-card[data-product=' + focusedPricingCardId + ']').addClass('focused')
  }

  // data-product="multistreaming"
}());

// header section height set
(function () {
  var setFullHeight = function () {
    $('.header .header-container').css({
      // minHeight: '100%',
      // height: window.innerHeight + 'px',
      // minHeight: window.innerHeight - 60 + 'px',
    });
  };

  // / media query to check
  var landscapeMQ = '(min-height: 1800px) and (orientation: portrait)';
  // matched or not
  var isPortraitMonitor = window.matchMedia(landscapeMQ).matches;
  if (!isPortraitMonitor) {
    window.addEventListener('load', setFullHeight);
    window.addEventListener('resize', setFullHeight);
  }
})();

// @phone: moving homepage feature preview images to text block 
(function () {
  // / media query to check
  var phoneMQ = '(max-width: 600px) and (orientation: portrait)';
  // matched or not
  var isPhoneView = window.matchMedia(phoneMQ).matches;
  if (isPhoneView) {
    Array.prototype.forEach.call(document.querySelectorAll('.snap_preview_wrap'), function (n) {
      var p = n.parentNode.parentNode
      if (p) {
        var t = p.querySelector('.titles_wrap')
        if (t) {
          t.insertBefore(n, t.querySelector('.desc'))
        }
      }
    })
  }
}());

// testimonial corousal
(function () {
  $('.review_list_actions button').click(function () {
    var el = $(this);
    var reviewList = $('.review_list');
    var maginToMove = parseInt(reviewList.find('.review_item').css('width'));
    var multiplier = parseInt(el.data().direction);

    var oldMargin = parseInt(reviewList.css('marginLeft')) || 0;
    var newMargin = oldMargin + maginToMove * multiplier;

    var maxRotate = reviewList.find('.review_item').length;
    var mostMargin = maginToMove * (maxRotate - 1);
    if (newMargin >= -mostMargin && newMargin <= 0) {
      reviewList.css({ marginLeft: newMargin });
    }
  });
})();

// faq block switcher
(function () {
  var onFaqActivate = function (el) {
    el.classList.add('collapsed');
    el.setAttribute('data-active', '1');
  };

  var faqBlocks = $('.faq_block');
  faqBlocks.click(function () {
    var elthis = this;
    var prevActive = null;
    faqBlocks.each(function (i, el) {
      if (!prevActive && el.hasAttribute('data-active')) {
        prevActive = el;
      }

      if (el !== elthis) {
        el.classList.remove('collapsed');
        el.removeAttribute('data-active');
      }
    });

    if (elthis !== prevActive) {
      onFaqActivate(elthis);
    }
  });

  function initAccordians(scope = document) {
    scope.querySelectorAll('.accordians-list').forEach((list) => {
      list.addEventListener('click', (e) => {
        const item = e.target.closest('.accordian-item');
        if (!item || !list.contains(item)) return;

        // 1) Activate clicked item; deactivate siblings
        list.querySelectorAll('.accordian-item.accordian-item-active')
          .forEach(el => { if (el !== item) el.classList.remove('accordian-item-active'); });
        item.classList.add('accordian-item-active');

        // 2) Swap the preview image in the sibling .accordians-img-wrap
        const id = item.getAttribute('data-accordian-item-id');
        const imgWrap = list.parentElement.parentElement.querySelector('.accordians-img-wrap');
        if (!imgWrap || !id) return;

        imgWrap.querySelectorAll('.accordian-img').forEach((img) => {
          const match = img.getAttribute('data-accordian-item-id') === id;
          img.classList.toggle('accordian-img-active', match);
        });
      });
    });
  }

  // run after DOM is ready
  initAccordians()

  function initPromoTabs(scope = document) {
    scope.querySelectorAll('.promo-tabs-list').forEach((tabsList) => {
      // Find sections list within the same parent/root
      const root = tabsList.parentElement;
      const sectionsList = root.querySelector('.promo-tab-sections-list');

      // Click to switch tabs
      tabsList.addEventListener('click', (e) => {
        const tab = e.target.closest('.promo-tab');
        if (!tab || !tabsList.contains(tab)) return;

        const id = tab.getAttribute('data-tab-id');
        if (!id) return;

        // 1) Activate clicked tab; deactivate other tabs
        tabsList.querySelectorAll('.promo-tab.promo-tab-active')
          .forEach(t => { if (t !== tab) t.classList.remove('promo-tab-active'); });
        tab.classList.add('promo-tab-active');

        // 2) Show matching section; hide others
        if (sectionsList) {
          sectionsList.querySelectorAll('.promo-tab-section').forEach((section) => {
            const shouldEnableThisSection = section.getAttribute('data-tab-id') === id;

            let demoVideo = section.querySelector('video')
            if (demoVideo) {
              demoVideo.pause()
              demoVideo.currentTime = 0

              section.querySelector('.video-demo-wrap').classList.remove('video-demo-wrap-playing')
            }

            // if (!shouldEnableThisSection) {
            //   console.log('was section active', section.classList.contains('promo-tab-section-active'))
            // }


            section.classList.toggle('promo-tab-section-active', shouldEnableThisSection);
          });
        }
      });

      // Optional: ensure an initial state (first tab active if none)
      const activeTab = tabsList.querySelector('.promo-tab.promo-tab-active') || tabsList.querySelector('.promo-tab');
      if (activeTab) {
        activeTab.classList.add('promo-tab-active');
        const id = activeTab.getAttribute('data-tab-id');
        if (sectionsList && id) {
          sectionsList.querySelectorAll('.promo-tab-section').forEach((section) => {
            const match = section.getAttribute('data-tab-id') === id;
            section.classList.toggle('promo-tab-section-active', match);
          });
        }
      }
    });
  }

  // Run after DOM is ready
  initPromoTabs();

  // Optional: set this to the root element that wraps your 4th fold tabs
  // If you don't have a dedicated wrapper, it will search the whole document.
  const PROMO_TABS_ROOT_SELECTOR = '#multistreaming-features .promo-tabs-list';

  function initExternalPromoTabLinks(scope = document) {
    const container = scope.querySelector('.product-features-list-wrap');
    if (!container) return;

    container.addEventListener('click', (e) => {
      const link = e.target.closest('a.feature-title[data-tab-target]');
      if (!link) return;

      e.preventDefault();

      const targetId = link.getAttribute('data-tab-target');
      if (!targetId) return;

      // Find the fourth-fold tab group root (scoped if possible)
      const root = scope.querySelector(PROMO_TABS_ROOT_SELECTOR) || document;

      // Find the matching tab by data-tab-id
      const targetTab = root.querySelector(`.promo-tab[data-tab-id="${CSS.escape(targetId)}"]`);
      if (!targetTab) return;

      // Trigger your existing tab logic by clicking the tab
      targetTab.click();

      // Smooth scroll to the tabs section (adjust selector if needed)
      const scrollTarget =
        root.querySelector('.promo-tabs-list') ||
        targetTab.closest('.promo-tabs-list') ||
        targetTab;
      if (scrollTarget) {
        // scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
        // Optional: move keyboard focus for accessibility
        targetTab.focus({ preventScroll: true });
      }
    });
  }

  // Run after DOM is ready
  initExternalPromoTabLinks();

  (function () {
    document.querySelectorAll('.video-demo-poster-overlay').forEach((posterOverlay) => {

      posterOverlay.addEventListener('click', () => {
        // console.log('posterOverlay', posterOverlay)

        let parentElement = posterOverlay.parentElement

        parentElement.querySelector('video').play();
        parentElement.classList.toggle('video-demo-wrap-playing');


      });

    });
  })

  function initVideoDemoToggles(scope = document) {
    const wraps = scope.querySelectorAll('.video-demo-wrap');
    if (!wraps.length) return;

    wraps.forEach(wrap => {
      const overlay = wrap.querySelector('.video-demo-poster-overlay');
      if (!overlay) return;

      overlay.addEventListener('click', () => {
        // Remove playing class from all wraps
        wraps.forEach(w => w.classList.remove('video-demo-wrap-playing'));

        wrap.querySelector('video').play()

        // Add playing class to the clicked one
        wrap.classList.add('video-demo-wrap-playing');
      });
    });
  }

  initVideoDemoToggles()

})();